<template>
  <el-container class="layout__wrap">
    <el-header class="header__wrap" height="68px">
      <div class="logo__wrap">
        <img class="logo-img" src="@/assets/img/login-logo.png" alt="" />
        <!-- <span class="logo-title">OA管理</span> -->
      </div>
      <div class="curRouter">
        <left-right-swiper-scroll class="swiperScroll" style="overflow: scroll">
          <div
            v-for="(item, index) in routerArr"
            :key="item.path"
            :class="item.path == $route.path ? 'item active' : 'item'"
            @click="handleRouter(item.path)"
          >
            <router-link class="path" :to="item.path">{{
              item.title
            }}</router-link>
            <i class="el-icon-close closeImg" @click="handleClone(index)"></i>
          </div>
        </left-right-swiper-scroll>
      </div>
      <div class="avatar__wrap">
        <div
          class="title"
          style="
            display: flex;
            align-items: center;
            color: #333;
            border-left: solid 1px #d5d5d5;
            padding-left: 20px;
          "
        >
          <div class="mes" v-if="department_module === 1 || department_module === 2" @click="toNews">
            <div class="mesr">
              <img
                style="width: 24px; height: 24px; margin-right: 10px"
                src="@/assets/img/m.png"
                alt=""
              />
              <div class="num" v-show="Number(unreadCount)+Number(salary_unread) > 0">{{ Number(unreadCount)+Number(salary_unread) }}</div>
              <div class="TUI">
                <div class="waitBan" style="position: relative;"  @click.stop="toPaysliptip"> 
                    <i style="font-size:30px;margin-right: 16px;color:#409EFF" class="el-icon-message"></i>待办消息
                    <div v-if="salary_unread > 0" style="position: absolute;top: 8px;left: 112px;background-color: #ff3939;border-radius: 10px;color: #fff;padding: 0px 6px;">{{salary_unread}}</div>
                </div>
                <div class="TUIs" @click="toNews" >
                  <TUIConversation
                    :filter="
                      (conversationList) =>
                        conversationList.filter(
                          (conversation) => conversation.unreadCount > 0
                        )
                    "
                    @getconversationList="getconversationList"
                  ></TUIConversation>
                </div>
                <div class="TUIb" @click="toNews">查看全部消息 ></div>
              </div>
            </div>
            消息
          </div>
          <div v-if="!!getAvatar">
            <el-image
              class="head-img"
              :src="getAvatar"
              :preview-src-list="[getAvatar]"
            ></el-image>
          </div>
          <div v-else class="head-img def_name_img">
            {{ userName.slice(-1) }}
          </div>
          <!-- <img
            style="width: 24px; margin-right: 10px"
            src="@/assets/img/default@2x.png"
            alt=""
          /> -->
          <div>{{ userName }}</div>
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          content="退出登录"
          placement="bottom"
        >
          <div class="logout" @click="logout">
            <i
              class="el-icon-switch-button"
              style="font-size: 20px; color: #333"
            ></i>
          </div>
        </el-tooltip>
      </div>
    </el-header>

    <el-container style="overflow-y: scroll">
      <NaviBar :isCollapse="isCollapse"></NaviBar>
      <el-main class="layout__main">
        <page-header></page-header>
        <keep-alive>
          <router-view :language="language"></router-view>
        </keep-alive>
      </el-main>
    </el-container>

    <!-- 修改密码 -->
    <el-dialog
      append-to-body
      width="500px"
      title=""
      :visible.sync="visible"
      :before-close="reset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template #title>
        <div class="el-dialog-title">修改密码</div>
      </template>

      <el-form
        v-loading="loading"
        class="saft_form"
        element-loading-text="加载中…"
        ref="elFormDom"
        label-width="130px"
        label-position="top"
        :model="form.data"
        :rules="form.rules"
        size="medium"
        hide-required-asterisk
      >
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            v-model="form.data.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="form.data.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import leftRightSwiperScroll from "@/layout/leftRightSwiperScroll.vue";
import { TUILogin } from "@tencentcloud/tui-core";
import { TUIConversation } from "../TUIKit";
import PageHeader from "./PageHeader.vue";
import NaviBar from "./NaviBar";
import { cancellation } from "@/api";
import { getStorage, setStorage, clear } from "@/storage";
import wsManager from "@/utils/websocket";
export default {
  name: "LayoutContainer",
  components: {
    NaviBar,
    PageHeader,
    leftRightSwiperScroll,
    TUIConversation,
  },
  props: { language: String },
  // computed: {
  //   ...mapGetters(['routerArr'])
  // },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.form.data.checkPass !== "") {
          this.$refs.elFormDom.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.data.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      user_picture: getStorage("user_picture"),
      unreadCount: 0,
      routerArr: [],
      curPath: this.$route.path,
      visible: false,
      loading: false,
      isCollapse: false,
      toggleMenu: false,
      userName: getStorage("userName"),
      form: {
        login: false,
        data: {
          password: "",
        },
        rules: {
          password: [
            { required: true, validator: validatePass, trigger: "blur" },
          ],
          checkPass: [
            { required: true, validator: validatePass2, trigger: "blur" },
          ],
        },
      },
      un_read: 0, //未读：0-没有未读消息；1-有未读消息；
      msgList: [],
      dialogVisible: false,
      department_module:getStorage('department_module'),
      salary_unread:0,
    };
  },
  watch: {
    $route(to, from) {
      this.getnewNotify();
      this.routerArr = getStorage("routerArr");
    },
  },
  mounted() {
    this.getnewNotify();
    this.routerArr = getStorage("routerArr");
  },
  methods: {
    getnewNotify() {
      this.$http.post("/admin/workSpace/newNotify", {}).then((res) => {
        if (res.code === 1) {
          this.salary_unread = res.data.salary_unread;
        }
      });
    },
    toNews() {
      this.$router.push({ path: "/home/home" });
    },
    toPaysliptip() {
      this.$router.push({ path: "/home/payslipTip" });
    },
    handleRouter(path) {
      this.curPath = path;
    },
    handleClone(index) {
      console.log(this.routerArr);
      if (index != 0) {
        this.routerArr.splice(index, 1);
        setStorage("routerArr", this.routerArr);
        let pathUrl = this.routerArr.at(-1).path;
        console.log(pathUrl);
        this.$router.push(pathUrl);
      }
    },
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      } else {
        this.visible = true;
      }
    },
    // 退出登录
    logout() {
      this.$confirm("请确认是否退出登录？", "提示", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 断开WebSocket连接
            console.log('退出登录，断开WebSocket连接...');
            wsManager.disconnect();
            
            // 删除token
            const deleteInfo = localStorage.getItem("TUIKit-userInfo");
            const deleteInfoList = JSON.parse(deleteInfo);
            clear();
            const options = {
              userId: deleteInfoList ? deleteInfoList.userId : "",
              token: deleteInfoList ? deleteInfoList.token : "",
              phone: deleteInfoList ? deleteInfoList.phone : "",
            };
            window.location.assign("/login");
            TUILogin.logout().then(() => {
              localStorage.removeItem("TUIKit-userInfo");
              cancellation(options);
            });

            done();
          } else {
            done();
          }
        },
      }).catch((err) => {});
    },
    // 修改密码
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.$http
            .post("/admin/index/updatePassword", {
              password: this.form.data.password,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.visible = false;
              } else {
                this.$message.error(res.msg);
              }
            });
        }
      });
    },
    // 展开、收起
    toggleColl() {
      this.isCollapse = !this.isCollapse;
      this.toggleMenu = !this.toggleMenu;
    },
    reset() {
      this.visible = false;
      this.dialogVisible = false;
      this.$refs.elFormDom.validateField();
    },
    toStr(data, key) {
      return data[key];
    },
    getconversationList(list) {
      if (
        list.some(
          (item) =>
            item.unreadCount > 0 && item.lastMessage.type == "TIMCustomElem"
        )
      ) {
        // console.log(
        //   list.some(
        //     (item) =>
        //       item.unreadCount > 0 && item.lastMessage.type == "TIMCustomElem"
        //   ),
        //   123
        // );
        this.$store.state.isunread = !this.$store.state.isunread;
        if (this.$route.path == "/approve/my") {
          this.$store.state.imcustom = !this.$store.state.imcustom;
        }
      }
      this.unreadCount = list.reduce((sum, item) => sum + item.unreadCount, 0);
    },
  },
  computed: {
   getAvatar() {
    return this.$store.getters.getAvatar || getStorage('Avatar')
   }
  }
};
</script>

<style scoped lang="scss">
.head-img {
  margin-right: 10px;
  width: 24px;
  height: 24px;
}
.def_name_img {
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
}
.layout__wrap {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  font-size: 14px;

  .header__wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    // background-image: linear-gradient(to right, $theme, #0bCFFF);
    .logo__wrap {
      width: 270px;
      display: flex;
      align-items: center;
      .logo-img {
        width: 90%;
      }
      .logo-title {
        font-size: 18px;
        font-weight: bold;
        color: #03549d;
        margin-left: 10px;
        margin-top: 10px;
        // font-style: italic;
      }
      .logoText {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
      }
      .J_menutoggle {
        color: #03549d;
        margin-left: 20px;
        display: none;
      }
    }
    .avatar__wrap {
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: end;
      width: 300px;

      .userName {
        margin-right: 20px;
      }
      .exit {
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      .item {
        text-align: center;
        cursor: pointer;
      }
      .logout {
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
  .layout__main {
    display: flex;
    flex-direction: column;
    padding: 0;
    background: #f2f5fc;
    position: relative;
    // transition: width .3s ease-in-out;

    .page-header__wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #595959;

      .title {
        height: 58px;
        line-height: 58px;
      }
    }

    & > div {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
  }
  .imageA {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
  }
}

.curRouter {
  flex: 1;
  user-select: none;

  .item {
    padding: 0 24px 0 10px;
    height: 38px;
    line-height: 38px;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    display: inline-block;
    margin-right: 10px;
    background: #f1f1f1;
    border-radius: 2px;
  }
  .item:hover {
    color: #1890ff;
  }
  .item.active {
    color: #1890ff;
    background: #e5f1ff;
  }
  .item.active .path {
    color: #1890ff;
  }
  .item:hover .closeImg {
    display: inline;
  }
  .closeImg {
    position: absolute;
    top: 12px;
    right: 5px;
    color: #898989;
    // display: none;
  }
  .path {
    color: #595959;
    text-decoration: none;
  }
  .list-btn {
    margin: 0 10px;
  }
}
.mes {
  padding: 0 20px 0 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 68px;
}
.mes:hover .TUI {
  display: block;
}
.mesr {
  position: relative;
}
.waitBan{
  cursor: pointer;
  padding: 10px 12px;
  display: flex;
  align-items: center;
}
.num {
  min-width: 16px;
  height: 16px;
  background: #ff3939;
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #ffffff;
  font-weight: bold;
  padding: 2px;
  border-radius: 16px;
  position: absolute;
  top: -8px;
  left: 16px;
}
.TUI {
  width: 401px;
  height: 528px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px #cccccc;
  border-radius: 10px;
  border: 1px solid #e5e5e5;
  position: absolute;
  z-index: 10;
  right: -20px;
  top: 40px;
  display: none;
}
.TUIs {
  height: calc(487px - 57px);
  overflow-y: scroll;
}
.TUIb {
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #007df2;
}
.swiperScroll::-webkit-scrollbar {
  height: 5px !important;
}
</style>
<style>
.el-dialog__headerbtn {
  top: 15px !important;
}
.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px !important;
  font-weight: bold !important;
}
</style>